import axios from "axios";

const nestInstance = axios.create({
  baseURL: window.location.origin,
  // timeout: 10000,
});

/**
 * If backend fails to return JSON, raise an error with the content
 * so we can see what went wrong.
 */
nestInstance.interceptors.response.use((response) => {
  if (!response.headers["content-type"].includes("application/json")) {
    throw new Error(`Received non-JSON response: ${response.data}`);
  }
  return response;
});

/**
 * fetch from origin location
 *
 * Raises error if response is not 2xx
 */
export function fetch_from_ns(
  method: "GET" | "POST" | "PUT" | "DELETE",
  url: string,
  body: object = {},
) {
  let responsePromise;
  switch (method) {
    case "GET":
      responsePromise = nestInstance.get(url, { params: body });
      break;
    case "POST":
      responsePromise = nestInstance.post(url, body);
      break;
    case "PUT":
      responsePromise = nestInstance.put(url, body);
      break;
    case "DELETE":
      responsePromise = nestInstance.delete(url, body);
      break;
    default:
      throw new Error(`Unsupported method: ${method}`);
  }
  return responsePromise.catch((error) => {
    // post to our error logging service
    console.error(
      `API_ERROR: ${url} ${error.response.status}:`,
      error,
      error.response.data,
    );
    const richError = new Error(
      `API_ERROR: ${url} ${error.response.status}: ${error.response.data} ${error}`,
    );

    // Although the backend logs the error, we also want to log it from here
    // because logging on these api calls is not very good.
    axios.post("/ajax/view/log_agent_error", {
      url: window.location.href,
      error: error.message,
      errorInfo: {
        request: {
          method,
          url,
          body,
        },
        response: error.response,
      },
    });

    throw richError;
  });
}

const yachtApiInstance = axios.create({
  // baseURL:  process.env.NODE_ENV !== "production" ? window.location.origin : "https://www.nestseekers.com",
  baseURL: window.location.origin,
});

export function fetch_from_yacht_api(
  method: string,
  url: string,
  body: object = {},
) {
  if (method === "GET") {
    return yachtApiInstance.get(url, {
      params: body,
      headers: { "x-requested-with": "XMLHttpRequest" },
    });
  } else if (method === "POST") {
    return yachtApiInstance.post(url, body);
  } else if (method === "PUT") {
    return yachtApiInstance.put(url, body);
  } else if (method === "DELETE") {
    return yachtApiInstance.delete(url, body);
  }
}

/**
 * opens popup and check to see if popup failed
 * (for safari browsers where we have async)
 * returns True if popup failed
 * @param url
 * @param w
 * @param h
 */
export function pop(url, title = "_blank", w = 1200, h = 1000) {
  const n = window.open(url, title, "width=" + w + ",height=" + h);
  if (n == null) {
    return true;
  }
  return false;
}
